import React from 'react'

// pagination styles
import './styles/pagination-styles.scss'

// icons
import { GrFormPrevious, GrFormNext } from "react-icons/gr";

// react router dom
import { Link } from 'react-router-dom';

export default function Pagination(props) {
    // props
    const { paginationLinks, routeName } = props

    return (
        <React.Fragment>
            {
                (paginationLinks && paginationLinks.length) ? (
                    <div id="st-pagination" className="">
                        <div className="st-pagination d-flex flex-wrap">
                            {
                                paginationLinks.map((item, key) => {
                                    const page = item.url ? item.url.split("?")[item.url.split("?").length - 1] : "page=0"

                                    return (
                                        <React.Fragment key={key}>
                                            {
                                                (item.url) ? ( // if exists
                                                    <React.Fragment>
                                                        {
                                                            // button previous
                                                            (item.label === "pagination.previous") ? (
                                                                <Link
                                                                    to={`${routeName}&${page}`}
                                                                    className={`pagination-link text-decoration-none link-previous ms-0 d-flex align-items-center justify-content-center
                                                                ${(!item.url) ? "disabled" : ""}`}>
                                                                    <GrFormPrevious
                                                                        size="18"
                                                                        className="icon position-relative"
                                                                    />
                                                                    <span className="st-fw-600 ms-1">Prev</span>
                                                                </Link>
                                                            ) : null
                                                        }
                                                    </React.Fragment>
                                                ) : null
                                            }
                                            {
                                                // button links
                                                ((item.label !== "pagination.previous") && (item.label !== "pagination.next")) ? (
                                                    <Link
                                                        to={`${routeName}&${page}`}
                                                        className={`pagination-link text-decoration-none link-count 
                                                        ${item.active ? "active disabled" : ""}
                                                        ${(!item.url) ? "disabled" : ""}`}>
                                                        {
                                                            (!item.url) ? "..." : item.label
                                                        }
                                                    </Link>
                                                ) : null
                                            }
                                            {
                                                (item.url) ? ( // if exists
                                                    <React.Fragment>
                                                        {
                                                            // button previous
                                                            (item.label === "pagination.next") ? (
                                                                <Link
                                                                    to={`${routeName}&${page}`}
                                                                    className={`pagination-link text-decoration-none link-next d-flex align-items-center justify-content-center
                                                        ${(!item.url) ? "disabled" : ""}`}>
                                                                    <span className="st-fw-600 me-1">Next</span>
                                                                    <GrFormNext
                                                                        size="16"
                                                                        className="icon position-relative"
                                                                    />
                                                                </Link>
                                                            ) : null
                                                        }
                                                    </React.Fragment>
                                                ) : null
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                        </div>
                    </div>
                ) : null
            }
        </React.Fragment>
    )
}
